import React, { useCallback } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
// eslint-disable-next-line jira/import/no-restricted-import
import { useProject } from '@atlassian/jira-navigation-apps-sidebar-common/src/controllers/project/index.tsx';
import type { TabDetailsProps } from '@atlassian/jira-navigation-kit-common/src/common/tabs-configuration-context/index.tsx';
import { getRouteForViewType } from '@atlassian/jira-navigation-kit-common/src/utils.tsx';
import TabDetails from './tab-details/index.tsx';
import messages from './messages.tsx';

export const SummaryDetails = ({ label, onConfirm, preview }: TabDetailsProps) => {
	const { formatMessage } = useIntl();
	const { data: project } = useProject();

	const onClick = useCallback(() => {
		const path = project?.key ? getRouteForViewType(project.key, 'SUMMARY') : undefined;
		onConfirm(path);
	}, [onConfirm, project?.key]);

	return (
		<TabDetails
			label={label}
			preview={preview}
			description={formatMessage(messages.summaryDescription)}
			onClick={onClick}
		/>
	);
};

export const BoardDetails = ({ label, onConfirm, preview }: TabDetailsProps) => {
	const { formatMessage } = useIntl();
	const { data: project } = useProject();

	const onClick = useCallback(() => {
		const path = project?.key ? getRouteForViewType(project.key, 'BOARD') : undefined;
		onConfirm(path);
	}, [onConfirm, project?.key]);

	return (
		<TabDetails
			label={label}
			preview={preview}
			description={formatMessage(messages.boardDescription)}
			onClick={onClick}
		/>
	);
};

export const ListDetails = ({ label, onConfirm, preview }: TabDetailsProps) => {
	const { formatMessage } = useIntl();
	const { data: project } = useProject();

	const onClick = useCallback(() => {
		const path = project?.key ? getRouteForViewType(project.key, 'LIST') : undefined;
		onConfirm(path);
	}, [onConfirm, project?.key]);

	return (
		<TabDetails
			label={label}
			preview={preview}
			description={formatMessage(messages.listDescription)}
			onClick={onClick}
		/>
	);
};

export const CalendarDetails = ({ label, onConfirm, preview }: TabDetailsProps) => {
	const { formatMessage } = useIntl();
	const { data: project } = useProject();

	const onClick = useCallback(() => {
		const path = project?.key ? getRouteForViewType(project.key, 'CALENDAR') : undefined;
		onConfirm(path);
	}, [onConfirm, project?.key]);

	return (
		<TabDetails
			label={label}
			preview={preview}
			description={formatMessage(messages.calendarDescription)}
			onClick={onClick}
		/>
	);
};

export const TimelineDetails = ({ label, onConfirm, preview }: TabDetailsProps) => {
	const { formatMessage } = useIntl();
	const { data: project } = useProject();

	const onClick = useCallback(() => {
		const path = project?.key ? getRouteForViewType(project.key, 'TIMELINE') : undefined;
		onConfirm(path);
	}, [onConfirm, project?.key]);

	return (
		<TabDetails
			label={label}
			preview={preview}
			description={formatMessage(messages.timelineDescription)}
			onClick={onClick}
		/>
	);
};

export const FormsDetails = ({ label, onConfirm, preview }: TabDetailsProps) => {
	const { formatMessage } = useIntl();
	const { data: project } = useProject();

	const onClick = useCallback(() => {
		const path = project?.key ? getRouteForViewType(project.key, 'FORMS') : undefined;
		onConfirm(path);
	}, [onConfirm, project?.key]);

	return (
		<TabDetails
			label={label}
			preview={preview}
			description={formatMessage(messages.formsDescription)}
			onClick={onClick}
		/>
	);
};

export const ApprovalsDetails = ({ label, onConfirm, preview }: TabDetailsProps) => {
	const { formatMessage } = useIntl();
	const { data: project } = useProject();

	const onClick = useCallback(() => {
		const path = project?.key ? getRouteForViewType(project.key, 'APPROVALS') : undefined;
		onConfirm(path);
	}, [onConfirm, project?.key]);

	return (
		<TabDetails
			label={label}
			preview={preview}
			description={formatMessage(messages.approvalsDescription)}
			onClick={onClick}
		/>
	);
};

export const AttachmentsDetails = ({ label, onConfirm, preview }: TabDetailsProps) => {
	const { formatMessage } = useIntl();
	const { data: project } = useProject();

	const onClick = useCallback(() => {
		const path = project?.key ? getRouteForViewType(project.key, 'ATTACHMENTS') : undefined;
		onConfirm(path);
	}, [onConfirm, project?.key]);

	return (
		<TabDetails
			label={label}
			preview={preview}
			description={formatMessage(
				fg('jira-issue-terminology-update-m4')
					? messages.attachmentsDescriptionIssueTerminologyRefreshM4
					: messages.attachmentsDescription,
			)}
			onClick={onClick}
		/>
	);
};

export const PagesDetails = ({ label, onConfirm, preview }: TabDetailsProps) => {
	const { formatMessage } = useIntl();
	const { data: project } = useProject();

	const onClick = useCallback(() => {
		const path = project?.key ? getRouteForViewType(project.key, 'PAGES') : undefined;
		onConfirm(path);
	}, [onConfirm, project?.key]);

	return (
		<TabDetails
			label={label}
			preview={preview}
			description={formatMessage(messages.pagesDescription)}
			onClick={onClick}
		/>
	);
};

export const IssuesDetails = ({ label, onConfirm, preview }: TabDetailsProps) => {
	const { formatMessage } = useIntl();
	const { data: project } = useProject();

	const onClick = useCallback(() => {
		const path = project?.key ? getRouteForViewType(project.key, 'ISSUES') : undefined;
		onConfirm(path);
	}, [onConfirm, project?.key]);

	return (
		<TabDetails
			label={label}
			preview={preview}
			description={formatMessage(
				fg('jira-issue-terminology-update-m4')
					? messages.issuesDescriptionIssueTerminologyRefreshM4
					: messages.issuesDescription,
			)}
			onClick={onClick}
		/>
	);
};

export const ReportsDetails = ({ label, onConfirm, preview }: TabDetailsProps) => {
	const { formatMessage } = useIntl();
	const { data: project } = useProject();

	const onClick = useCallback(() => {
		const path = project?.key ? getRouteForViewType(project.key, 'REPORTS') : undefined;
		onConfirm(path);
	}, [onConfirm, project?.key]);

	return (
		<TabDetails
			label={label}
			preview={preview}
			description={formatMessage(
				fg('jira-issue-terminology-update-m4')
					? messages.reportsDescriptionIssueTerminologyRefreshM4
					: messages.reportsDescription,
			)}
			onClick={onClick}
		/>
	);
};

export const ComponentsDetails = ({ label, onConfirm, preview }: TabDetailsProps) => {
	const { formatMessage } = useIntl();
	const { data: project } = useProject();

	const onClick = useCallback(() => {
		const path = project?.key ? getRouteForViewType(project.key, 'COMPONENTS') : undefined;
		onConfirm(path);
	}, [onConfirm, project?.key]);

	return (
		<TabDetails
			label={label}
			preview={preview}
			description={formatMessage(messages.componentsDescription)}
			onClick={onClick}
		/>
	);
};

export const ShortcutsDetails = ({ label, onConfirm, preview }: TabDetailsProps) => {
	const { formatMessage } = useIntl();

	const onClick = useCallback(() => onConfirm(), [onConfirm]);

	return (
		<TabDetails
			label={label}
			preview={preview}
			description={formatMessage(messages.shortcutsDescription)}
			onClick={onClick}
		/>
	);
};

export const AppDetails = ({ label, onConfirm, preview }: TabDetailsProps) => {
	const { formatMessage } = useIntl();

	const onClick = useCallback(() => onConfirm(), [onConfirm]);

	return (
		<TabDetails
			preview={preview}
			label={label}
			description={formatMessage(messages.appDescription)}
			onClick={onClick}
		/>
	);
};

export const ArchivedIssuesDetails = ({ label, onConfirm, preview }: TabDetailsProps) => {
	const { formatMessage } = useIntl();
	const { data: project } = useProject();

	const onClick = useCallback(() => {
		const path = project?.key ? getRouteForViewType(project.key, 'ARCHIVED_ISSUES') : undefined;
		onConfirm(path);
	}, [onConfirm, project?.key]);

	return (
		<TabDetails
			preview={preview}
			label={label}
			description={formatMessage(
				fg('jira-issue-terminology-update-m4')
					? messages.archivedIssuesDescriptionIssueTerminologyRefreshM4
					: messages.archivedIssuesDescription,
			)}
			onClick={onClick}
		/>
	);
};
